import React from 'react'

import DeepLinkButton from './DeepLinkButton'
import OpenStoreButton from './OpenStoreButton'

import './css/index.css'

import {
  BrowserRouter as Router,
  Route,
  Link
} from 'react-router-dom'

import {
    isIOS,
    isAndroid
} from "react-device-detect";

import LocalizedStrings from 'react-localization';

  let strings = new LocalizedStrings({
   en:{
     welcomeText:"Join to clan",
     welcomeText2:"in Tanks A Lot!",
     deepLinkButtonText: "ACCEPT AND PLAY",
	 deepLinkButtonTitle: "Open",
     addFriendButtonText: "INSTALL GAME",
	 addFriendButtonTitle: "Open",
     privacyButtonText: "Privacy Policy",
     supportButtonText: "Support",
     blueButtonImage: './images/blue_button.png',
     yellowButtonImage: './images/yellow_button.png',
     ru_flag: "false",
     offset: "false",
     hintText: 'If you pressed "Accept and Play" and nothing',
       hintText2: 'happened, please try ',
       hintText3: 'to open this page in browser',
       btn1: 'btn1',
       btn2: 'btn2'
   },
   ru: {
     welcomeText:"Присоединиться к клану",
     welcomeText2:"в Tanks A Lot!",
     deepLinkButtonText: "ПРИНЯТЬ И ИГРАТЬ",
	 deepLinkButtonTitle: "Открыть",
     addFriendButtonText: "УСТАНОВИТЬ ИГРУ",
	 addFriendButtonTitle: "Открыть",
     privacyButtonText: "Политика Конфиденциальности",
     supportButtonText: "Support",
     blueButtonImage: './images/blue_button.png',
     yellowButtonImage: './images/yellow_button.png',
     ru_flag: "true",
 offset: "false",
     hintText: 'Если Вы нажали "Принять и играть", но ничего', 
       hintText2: 'не произошло, попытайтесь',
       hintText3: 'открыть эту страницу в браузере',
       btn1: 'btn1_ru',
       btn2: 'btn2_ru'
   },
   da: {
     welcomeText:"Slut dig til din ven",
     welcomeText2:"i Tanks A Lot!",
     deepLinkButtonText: "ACCEPTER OG SPIL",
   deepLinkButtonTitle: "Открыть",
     addFriendButtonText: "INSTALLER SPIL",
   addFriendButtonTitle: "Открыть",
     privacyButtonText: "Privatlivspolitik",
     supportButtonText: "Support",
     blueButtonImage: './images/blue_button.png',
     yellowButtonImage: './images/yellow_button.png',
     ru_flag: "true",
 offset: "false",
     hintText: 'Hvis du trykkede på ”Accepter og spil”,', 
       hintText2: 'og der ikke skete noget,',
       hintText3: 'bedes du venligst åbne denne siden i en anden browser.',
       btn1: 'btn1_ru',
       btn2: 'btn2_ru'
   },

   nl: {
     welcomeText:"Speel met je vriend",
     welcomeText2:"In Tanks a Lot!",
     deepLinkButtonText: "ACCEPTEREN EN SPELEN",
   deepLinkButtonTitle: "Открыть",
     addFriendButtonText: "SPEL INSTALLEREN",
   addFriendButtonTitle: "Открыть",
     privacyButtonText: "Privacybeleid",
     supportButtonText: "Support",
     blueButtonImage: './images/blue_button.png',
     yellowButtonImage: './images/yellow_button.png',
     ru_flag: "true",
 offset: "false",
     hintText: 'Als je op "Accepteren en spelen” klikt', 
       hintText2: 'en er gebeurt niks, probeer ',
       hintText3: 'dan deze pagina in je webbrowser te openen.',
       btn1: 'btn1_ru',
       btn2: 'btn2_ru'
   },

   fi: {
     welcomeText:"Liity kaverisi",
     welcomeText2:"seuraan pelissä Tanks A Lot!",
     deepLinkButtonText: "HYVÄKSY JA PELAA",
   deepLinkButtonTitle: "Открыть",
     addFriendButtonText: "ASENNA PELI",
   addFriendButtonTitle: "Открыть",
     privacyButtonText: "Tietosuojalauseke",
     supportButtonText: "Support",
     blueButtonImage: './images/blue_button.png',
     yellowButtonImage: './images/yellow_button.png',
     ru_flag: "true",
 offset: "false",
     hintText: 'Jos painoit ”Hyväksy ja pelaa”,', 
       hintText2: 'eikä mitään tapahtunut,',
       hintText3: 'yritä avata sivu selaimessa.',
       btn1: 'btn1_ru',
       btn2: 'btn2_ru'
   },

   fr: {
     welcomeText:"Rejoignez vos amis",
     welcomeText2:"dans Tanks A Lot !",
     deepLinkButtonText: "ACCEPTER ET JOUER",
   deepLinkButtonTitle: "Открыть",
     addFriendButtonText: "INSTALLER LE JEU",
   addFriendButtonTitle: "Открыть",
     privacyButtonText: "Politique de confidentialité",
     supportButtonText: "Support",
     blueButtonImage: './images/blue_button.png',
     yellowButtonImage: './images/yellow_button.png',
     ru_flag: "true",
 offset: "false",
     hintText: 'Si vous avez sélectionné « Accepter et jouer » ', 
       hintText2: 'veuillez essayer',
       hintText3: 'd’ouvrir cette page dans un navigateur.',
       btn1: 'btn1_ru',
       btn2: 'btn2_ru'
   },

   de: {
     welcomeText:"Spiel mit deinem Freund",
     welcomeText2:"Tanks A Lot!",
     deepLinkButtonText: "ANNEHMEN UND SPIELEN",
   deepLinkButtonTitle: "Открыть",
     addFriendButtonText: "SPIEL INSTALLIEREN",
   addFriendButtonTitle: "Открыть",
     privacyButtonText: "Datenschutzregelung",
     supportButtonText: "Support",
     blueButtonImage: './images/blue_button.png',
     yellowButtonImage: './images/yellow_button.png',
     ru_flag: "true",
 offset: "false",
     hintText: 'Öffne diese Seite bitte mit einem anderen Browser,', 
       hintText2: 'falls du auf „Annehmen und spielen“',
       hintText3: 'geklickt hast und nichts passiert.',
       btn1: 'btn1_ru',
       btn2: 'btn2_ru'
   },

   id: {
     welcomeText:"Bergabunglah dengan Temanmu",
     welcomeText2:"di Tanks A Lot!",
     deepLinkButtonText: "TERIMA DAN MAINKAN",
   deepLinkButtonTitle: "Открыть",
     addFriendButtonText: "INSTAL GAME",
   addFriendButtonTitle: "Открыть",
     privacyButtonText: "Kebijakan Privasi",
     supportButtonText: "Support",
     blueButtonImage: './images/blue_button.png',
     yellowButtonImage: './images/yellow_button.png',
     ru_flag: "true",
 offset: "false",
     hintText: 'Jika kamu menekan "Terima dan Mainkan"', 
       hintText2: 'dan tidak ada yang terjadi,',
       hintText3: 'cobalah membuka halaman ini di browser.',
       btn1: 'btn1_ru',
       btn2: 'btn2_ru'
   },

   it: {
     welcomeText:"Gioca insieme al tuo amico",
     welcomeText2:"a Tanks A Lot!",
     deepLinkButtonText: "ACCETTA E GIOCA",
   deepLinkButtonTitle: "Открыть",
     addFriendButtonText: "INSTALLA GIOCO",
   addFriendButtonTitle: "Открыть",
     privacyButtonText: "Informativa sulla privacy",
     supportButtonText: "Support",
     blueButtonImage: './images/blue_button.png',
     yellowButtonImage: './images/yellow_button.png',
     ru_flag: "true",
 offset: "false",
     hintText: 'Se hai premuto "Accetta e gioca"', 
       hintText2: 'e non è successo niente,',
       hintText3: 'prova ad aprire questa pagina nel browser.',
       btn1: 'btn1_ru',
       btn2: 'btn2_ru'
   },

   ms: {
     welcomeText:"Sertai Rakan Anda",
     welcomeText2:"dalam Tanks A Lot!",
     deepLinkButtonText: "TERIMA DAN MAIN",
   deepLinkButtonTitle: "Открыть",
     addFriendButtonText: "MEMASANG PERMAINAN",
   addFriendButtonTitle: "Открыть",
     privacyButtonText: "Dasar Privasi",
     supportButtonText: "Support",
     blueButtonImage: './images/blue_button.png',
     yellowButtonImage: './images/yellow_button.png',
     ru_flag: "true",
 offset: "false",
     hintText: 'Jika anda menekan "Terima dan Main"', 
       hintText2: 'dan tiada apa-apa berlaku,',
       hintText3: 'sila cuba untuk membuka halaman ini dalam pelayar.',
       btn1: 'btn1_ru',
       btn2: 'btn2_ru'
   },

   nb: {
     welcomeText:"Bli med vennen din",
     welcomeText2:"I Tanks a Lot!",
     deepLinkButtonText: "AKSEPTER OG SPILL",
   deepLinkButtonTitle: "Открыть",
     addFriendButtonText: "INSTALLER SPILL",
   addFriendButtonTitle: "Открыть",
     privacyButtonText: "Retningslinjer for personvern",
     supportButtonText: "Support",
     blueButtonImage: './images/blue_button.png',
     yellowButtonImage: './images/yellow_button.png',
     ru_flag: "true",
 offset: "false",
     hintText: 'Hvis du valgte “Aksepter og Spill”', 
       hintText2: 'og ingenting skjedde,',
       hintText3: 'prøv å åpne denne siden i en nettleser.',
       btn1: 'btn1_ru',
       btn2: 'btn2_ru'
   },


   pl: {
     welcomeText:"Dołącz do swojego znajomego",
     welcomeText2:"w Tanks A Lot!",
     deepLinkButtonText: "ZAAKCEPTUJ I ZAGRAJ",
   deepLinkButtonTitle: "Открыть",
     addFriendButtonText: "ZAINSTALUJ GRĘ",
   addFriendButtonTitle: "Открыть",
     privacyButtonText: "Polityka prywatności",
     supportButtonText: "Support",
     blueButtonImage: './images/blue_button.png',
     yellowButtonImage: './images/yellow_button.png',
     ru_flag: "true",
 offset: "false",
     hintText: 'Jeśli po kliknięciu przycisku „Zaakceptuj i zagraj”', 
       hintText2: 'nic się nie wydarzyło,',
       hintText3: 'spróbuj otworzyć stronę w przeglądarce.',
       btn1: 'btn1_ru',
       btn2: 'btn2_ru'
   },

   pt: {
     welcomeText:"Encontre seus amigos",
     welcomeText2:"no Tanks A Lot!",
     deepLinkButtonText: "ACEITAR E JOGAR",
   deepLinkButtonTitle: "Открыть",
     addFriendButtonText: "INSTALAR JOGO",
   addFriendButtonTitle: "Открыть",
     privacyButtonText: "Política de Privacidade",
     supportButtonText: "Support",
     blueButtonImage: './images/blue_button.png',
     yellowButtonImage: './images/yellow_button.png',
     ru_flag: "true",
 offset: "false",
     hintText: 'Se você pressionar "Aceitar e Jogar"', 
       hintText2: 'e nada acontecer, tente',
       hintText3: 'abrir esta página no navegador.',
       btn1: 'btn1_ru',
       btn2: 'btn2_ru'
   },

   es: {
     welcomeText:"¡Únete a tu amigo",
     welcomeText2:"en Tanks A Lot!",
     deepLinkButtonText: "ACEPTAR Y JUGAR",
   deepLinkButtonTitle: "Открыть",
     addFriendButtonText: "INSTALAR JUEGO",
   addFriendButtonTitle: "Открыть",
     privacyButtonText: "Política de privacidad",
     supportButtonText: "Support",
     blueButtonImage: './images/blue_button.png',
     yellowButtonImage: './images/yellow_button.png',
     ru_flag: "true",
 offset: "false",
     hintText: 'Si has pulsado "Aceptar y jugar" y no', 
       hintText2: 'ha pasado nada, intenta abrir esta',
       hintText3: 'página en el navegador, por favor.',
       btn1: 'btn1_ru',
       btn2: 'btn2_ru'
   },

   sv: {
     welcomeText:"Spela med din vän",
     welcomeText2:"i Tanks A Lot!",
     deepLinkButtonText: "ACCEPTERA OCH SPELA",
   deepLinkButtonTitle: "Открыть",
     addFriendButtonText: "INSTALLERA SPEL",
   addFriendButtonTitle: "Открыть",
     privacyButtonText: "Integritetspolicy",
     supportButtonText: "Support",
     blueButtonImage: './images/blue_button.png',
     yellowButtonImage: './images/yellow_button.png',
     ru_flag: "true",
 offset: "false",

     hintText: 'Om du tryckte på ”acceptera och spela”', 
       hintText2: 'utan att någonting hände, ',
       hintText3: 'försök att öppna den här sidan i webbläsaren.',
       btn1: 'btn1_ru',
       btn2: 'btn2_ru'
   },

   tr: {
     welcomeText:"Tanks A Lot'ta",
     welcomeText2:"arkadaşına katıl!",
     deepLinkButtonText: "KABUL ET VE OYNA",
   deepLinkButtonTitle: "Открыть",
     addFriendButtonText: "OYUNU YÜKLE",
   addFriendButtonTitle: "Открыть",
     privacyButtonText: "Gizlilik Politikası",
     supportButtonText: "Support",
     blueButtonImage: './images/blue_button.png',
     yellowButtonImage: './images/yellow_button.png',
     ru_flag: "true",
      offset: "false",
     hintText: '"Kabul Et ve Oyna" tuşuna bastığın halde', 
       hintText2: 'hiçbir şey olmadıysa lütfen',
       hintText3: 'bu sayfayı tarayıcıda açmayı dene.',
       btn1: 'btn1_ru',
       btn2: 'btn2_ru'
   },

   vi: {
     welcomeText:"Hãy tham gia cùng bạn của bạn.",
     welcomeText2:"trong Tanks A Lot!",
     deepLinkButtonText: "CHẤP NHẬN VÀ CHƠI",
   deepLinkButtonTitle: "Открыть",
     addFriendButtonText: "CÀI ĐẶT TRÒ CHƠI",
   addFriendButtonTitle: "Открыть",
     privacyButtonText: "Chính sách Quyền riêng tư",
     supportButtonText: "Support",
     blueButtonImage: './images/blue_button.png',
     yellowButtonImage: './images/yellow_button.png',
     ru_flag: "true",
 offset: "false",
     hintText: 'Nếu bạn đã nhấn “Chấp nhận và chơi”', 
       hintText2: 'nhưng không có gì xảy ra,',
       hintText3: 'vui lòng mở trang này trong trình duyệt.',
       btn1: 'btn1_ru',
       btn2: 'btn2_ru'
   },

   zh: {
     welcomeText:"加入您在Tanks A Lot 中",
     welcomeText2:"的朋友！",
     deepLinkButtonText: "安装游戏",
   deepLinkButtonTitle: "Открыть",
     addFriendButtonText: "隐私政策",
   addFriendButtonTitle: "Открыть",
     privacyButtonText: "隐私政策",
     supportButtonText: "Support",
     blueButtonImage: './images/blue_button.png',
     yellowButtonImage: './images/yellow_button.png',
     ru_flag: "true",
 offset: "true",
     hintText: '如果您按下了“接受并开始游戏”', 
       hintText2: '且没有任何回应，',
       hintText3: '请尝试在浏览器中打开此页面。',
       btn1: 'btn1_ru',
       btn2: 'btn2_ru'
   },

   ja: {
     welcomeText:"友だちもプレイ中",
     welcomeText2:"Tanks A Lotで一緒にプレイ！",
     deepLinkButtonText: "承認してプレイする",
   deepLinkButtonTitle: "Открыть",
     addFriendButtonText: "ゲームのインストール",
   addFriendButtonTitle: "Открыть",
     privacyButtonText: "プライバシーポリシー",
     supportButtonText: "Support",
     blueButtonImage: './images/blue_button.png',
     yellowButtonImage: './images/yellow_button.png',
     ru_flag: "true",
 offset: "true",
     hintText: '「承認してプレイ」を押しても何も起きない場合はこのペ', 
       hintText2: 'ージをブラウザで',
       hintText3: '開いてみてください。',
       btn1: 'btn1_ru',
       btn2: 'btn2_ru'
   },

   ko: {
     welcomeText:"당신의친구",
     welcomeText2:"님과 함께 플레이!",
     deepLinkButtonText: "동의 후플레이",
   deepLinkButtonTitle: "Открыть",
     addFriendButtonText: "게임 설치",
   addFriendButtonTitle: "Открыть",
     privacyButtonText: "개인정보 처리방침",
     supportButtonText: "Support",
     blueButtonImage: './images/blue_button.png',
     yellowButtonImage: './images/yellow_button.png',
     ru_flag: "true",
offset: "true", 
     hintText: '“동의 후플레이”를 눌러도', 
       hintText2: '시작되지 않는다면',
       hintText3: '인터넷브라우저에서시도해보세요.',
       btn1: 'btn1_ru',
       btn2: 'btn2_ru'
   }
  });

let config = {
     
  };

const Home = (props) => (
  <div>
    <div className="mainPageText">-</div>
     <div className="mainPageText2">
<p>{props.welcomeText}</p>
<p className="friendNameStyle">{props.friendName}</p>
<p>{props.welcomeText2}</p>
     </div>
  </div>
);


function HintLabel(props)
{
    if (props.showHint === 1)
    {
        return <div id="showtxt" className='hidetxt'><span>{strings.hintText}<br/>{strings.hintText2}<br/>{strings.hintText3}</span></div>;
    }
    else {
        return null;
    }
}


class Landing extends React.Component {

    androidURL = "market://details?id=com.idspe.tanks2";

    iosURL = "https://itunes.apple.com/app/id1344713773";

    androidURL_nonmobile = "https://play.google.com/store/apps/details?id=com.idspe.tanks2";

    handleClickBlue() {

        if(isIOS){
            console.log("iOS: open store button pressed! ");
            window.location.href = this.iosURL;
        }
        else {
            if (isAndroid) {
                console.log("Android: open store button pressed! ");
                window.location.href = this.androidURL;
            }
            else {
                console.log("non-mobile device");
                window.location.href = this.androidURL_nonmobile;
            }
        }
    }
    
getParams(search_string) {    
      var parse = function(params, pairs)
      {
          var pair = pairs[0];
          var parts = pair.split('=');
          var key = decodeURIComponent(parts[0]);
          var value = decodeURIComponent(parts.slice(1).join('='));

          // Handle multiple parameters of the same name
          if (typeof params[key] === "undefined") {
              params[key] = value;
          } else {
              params[key] = [].concat(params[key], value);
          }

          return pairs.length == 1 ? params : parse(params, pairs.slice(1))
      }

      // Get rid of leading ?
      return search_string.length == 0 ? {} : parse({}, search_string.substr(1).split('&'));
      
  }
//todo: выделить методы для работы с GET параметрами в отдельный js-файл
  getFriendId() {
      var params = this.getParams(window.location.search);

      return params["nick"];
  }
  
    openDeepLink() {
        var params = this.getParams(window.location.search);

        console.log("tanksalot://AcceptClanRequest?id=" + params["id"]);

        window.location.href = "tanksalot://AcceptClanRequest?id=" + params["id"];
    }

    handleClickYellow() {
        
        this.setFlag();
        console.log("button pressed yellow! ");

        this.openDeepLink();
    }

    isAsianLanguage() {

      if(strings.offset == "true")
      {
        return true;
      }

      return false;
    }

    getButtonTextStyle(){
      if(this.isAsianLanguage())
      {
        return 'txt_in_btn_asia';
      }

      return 'txt_in_btn';
    }
  
  
  constructor(props, context) {
    super(props, context);

   // this.handleClick = this.handleClick.bind(this);

      this.handleClickBlue = this.handleClickBlue.bind(this);
      this.handleClickYellow = this.handleClickYellow.bind(this);
      
    this.state = {
		  showHint: 0,
          friendName: this.getFriendId()
    };

    //strings.setLanguage('ru');
    
  }
 
setFlag() {
  this.setState({showHint: 1});
}


render() {
    return (
    <Router>
<div>
    {/*<div>v.00007</div>*/}
    
    <div className='back'>
        <div className='centerdiv'>
          <div className='txt'><span>{strings.welcomeText}<br/>
            <span className='txtFriend'>{this.getFriendId()}</span><br/>
              {strings.welcomeText2}</span></div>
            
          
            
          <div id='btn1' className={strings.btn1} onClick={this.handleClickYellow}>
              {/*<div className='btnstyle1'>
 
            </div>*/}

              <div className='btnstyle1'><span className={this.getButtonTextStyle()}>{strings.deepLinkButtonText}</span></div>
          </div>
            
          <HintLabel showHint={this.state.showHint}/>
         
          <div className={strings.btn2} onClick={this.handleClickBlue}>
              {/* <div className='btnstyle2'>
                
            </div>*/}
             <div className='btnstyle2'><span className={this.getButtonTextStyle()}>{strings.addFriendButtonText}</span></div>
          </div>
            
        </div>
    </div>
    
  <footer>
    <div className='footerdiv1'><a className='policy' href="https://highcore.io/pp/">{strings.privacyButtonText}</a></div>
    <div className='footerdiv2'>
      <div className='centerfoot'>
        <div className='societyBox'>
          <div className='society vk'><a href='https://vk.com/tanksalotgame'></a></div>
        </div>
        <div className='societyBox'>
          <div className='society f'><a href='https://www.facebook.com/TanksALotGame'></a></div>
        </div>
        <div className='societyBox'>
          <div className='society you'><a href='https://www.youtube.com/channel/UCt2KL_2Nyffmfm34CJfyS7w'></a></div>
        </div>
        <div className='societyBox'>
          <div className='society inst'><a href='https://www.instagram.com/tanksalot_game'></a></div>
        </div>
      </div>
    </div>
  </footer>
</div>
{/*
<Home welcomeText={strings.welcomeText} friendName={this.state.friendName} welcomeText2={strings.welcomeText2}/>
 <OpenStoreButton title={strings.addFriendButtonText} ru={strings.ru_flag} buttonName={strings.addFriendButtonText}/>
        
    <Hint showHint={this.state.showHint} hintText={strings.hintText}/>

 <DeepLinkButton showHintCallback={this.setFlag} title={strings.deepLinkButtonTitle} ru={strings.ru_flag} buttonName={strings.deepLinkButtonText} />

        <Footer supportButtonName={strings.supportButtonText} privacyButtonName={strings.privacyButtonText}/>
*/}

    </Router>
  )
  }
}
export default Landing


// WEBPACK FOOTER //
// ./src/App.js